import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import {translate} from "react-i18next";

class ConfirmView extends Component {

  constructor(props) {
    super(props);
    this.config = props.config;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.messages = {
      update: 'account_updated',
      remove: 'account_removed',
      create: 'account_created',
      forgot: 'send_confirmation',
      reset: 'change_password_success',
      resetError: 'change_password_error',
      createdOrder: 'order_created',
      assert: 'payment_success',
      assertError: 'payment_error'
    };
  }


  handleSubmit() {
    this.config.onConfirm();
  }

  render() {
    const {t} = this.props;
    return (
      <div className="form">
        <div className={classNames('form__confirm', {
          'form__confirm--success': this.config.success,
          'form__confirm--error': !this.config.success,
        })}>
        </div>
        <div className="form__title form__title--wihout-background">{t(this.messages[this.config.action])}</div>
        <div className="form__row">
          <button className="form__button" onClick={this.handleSubmit}><strong>{t('continue')}</strong></button>
        </div>
      </div>
    );
  }
}

ConfirmView.propTypes = {
  config: PropTypes.object.isRequired
};

export default translate('translations')(ConfirmView);



// WEBPACK FOOTER //
// ./src/components/Helpers/ConfirmView.js